import { Stacked, Typography } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ContentState } from '@/components/contentState/ContentState';
import { DashboardWidgets } from '@/components/dashboard/DashboardWidgets';
import { Nullable } from '@/types/generic';
import { StatusTranslationKey } from '@/types/status';
import { UserConfigWidgetDefinition } from '@/types/userConfigs';
import { isNullish } from '@/utils/predicates';
import { SwitchToClassicEntityButton } from '../button/SwitchToClassicEntityButton';

export const DashboardContentHeading = ({
  children,
  preHeadingActions,
  headerActions,
}: {
  children: ReactNode;
  preHeadingActions?: ReactNode;
  headerActions?: ReactNode;
}) => {
  const { t } = useTranslation('navigation');
  const { pathname } = useLocation();
  const heading = t('secondary.dashboard');

  /* Display on player and team dashboards */
  const displaySwitchToClassicButton = ['player', 'team'].includes(pathname.split('/')[2]);

  return (
    <div className="flex flex-col gap-2">
      <div className="bg-canvas-tertiary-main w-full flex items-center justify-between px-4 py-2">
        <Stacked direction="row" alignItems="center">
          {preHeadingActions}
          <Typography variant="headingRegular">{heading}</Typography>
        </Stacked>
        <Stacked direction="row" alignItems="center">
          {headerActions}
          {displaySwitchToClassicButton && <SwitchToClassicEntityButton />}
        </Stacked>
      </div>
      {children}
    </div>
  );
};

export const DashboardContent = ({
  entityId,
  dashboardWidgets,
}: {
  entityId: Nullable<number>;
  dashboardWidgets: UserConfigWidgetDefinition[];
}) => (
  <DashboardContentHeading>
    {isNullish(entityId) ? (
      <ContentState status={StatusTranslationKey.ERROR} />
    ) : (
      <DashboardWidgets entityId={entityId} widgets={dashboardWidgets} />
    )}
  </DashboardContentHeading>
);
